import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../App/App';
import { Fragment } from 'react';
import jwt from 'jwt-decode'
import qs from 'querystring'
import axios from 'axios';
import swal from 'sweetalert';

function Profile() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const initialState = {
        init: true,
        status: (jwt(localStorage.getItem('token-helpdesk-umy')).role_id != 'student' && jwt(localStorage.getItem('token-helpdesk-umy')).role_id != 'staff') ? 'admin' : jwt(localStorage.getItem('token-helpdesk-umy')).role_id,
        id: '',
        name: '',
        displayname: '',
        email: '',
        workunit: '',
        message: { completed: 0, uncompleted: 0 },
        password: false,

        dob: '',
        position: ''
    }
    const [dataForm, setdataForm] = useState(initialState)

    const [statePassword, setstatePassword] = useState({ old: '', errOld: null, new: '', errNew: null, confirm: '', errConfirm: null, is_edit: dataForm.password })
    const handleEditPassword = () => {
        setstatePassword({
            ...statePassword,
            old: '',
            confirm: '',
            new: '',
            errConfirm: null,
            errNew: null,
            errOld: null,
            is_edit: !statePassword.is_edit
        })
    }

    const handleInputChange = (event) => {
        const regexp = /^\S*$/;
        if (regexp.test(event.target.value)) {
            setstatePassword({
                ...statePassword,
                [event.target.name]: event.target.value,
                errOld: (event.target.name === 'old') ? null : statePassword.errOld,
                errConfirm: (event.target.name === 'confirm') ? null : statePassword.errConfirm,
                errNew: (event.target.name === 'new') ? null : statePassword.errNew,
            })
        }
    }

    const handleSubmitPassword = () => {
        if (statePassword.new != '' && statePassword.old != '' && statePassword.confirm != '' && statePassword.new == statePassword.confirm) {
            submitPassword()
            setstatePassword({
                ...statePassword,
                errNew: null,
                errConfirm: null,
                errOld: null
            })
        } else {
            setstatePassword({
                ...statePassword,
                errOld: statePassword.old === '' ? 'Please fill in your current password.' : statePassword.errOld,
                errNew: statePassword.new === '' ? 'Please fill in your new password.' : statePassword.errNew,
                errConfirm: (statePassword.confirm === '' ? 'Please fill in your confirmation password.' : statePassword.new != statePassword.confirm ? 'Passwords must be same.' : statePassword.errConfirm)
            })
        }
    }

    const submitPassword = () => {
        const reqBody = {
            new_password: statePassword.new,
            confirm_password: statePassword.confirm,
            old_password: statePassword.old
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }

        axios.post('/api/v1/helpdesk/dashboard/password', qs.stringify(reqBody), config)
            .then(res => {
                swal("Success!", "Pssword has been updated!", "success", {
                    button: "OK",
                });
                handleEditPassword()
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.status === 'invalid') {
                        let newPass = null
                        let confirmPass = null
                        let oldPass = null
                        err.response.data.errors.map(err => {
                            newPass = (err.param == 'new_password') ? err.msg : newPass
                            confirmPass = (err.param == 'confirm_password') ? err.msg : confirmPass
                            oldPass = (err.param == 'old_password') ? err.msg : oldPass
                        })
                        setstatePassword({
                            ...statePassword,
                            errConfirm: confirmPass,
                            errOld: oldPass,
                            errNew: newPass
                        })
                    } else if (err.response.data.message === 'Unauthorized') {
                        setstatePassword({
                            ...statePassword,
                            errOld: 'Please enter the correct password.'
                        })
                    } else {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }

                }
            })
    }

    useEffect(() => {
        if (dataForm.init) {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/dashboard/profile/${dataForm.status}/${jwt(localStorage.getItem('token-helpdesk-umy')).id}`, config)
                .then(res => {
                    setdataForm({
                        ...dataForm,
                        init: false,
                        id: res.data.data.id,
                        name: res.data.data.name,
                        displayname: res.data.data.displayname,
                        email: res.data.data.email,
                        workunit: res.data.data.workunit,
                        message: res.data.data.message,
                        password: res.data.data.password,
                        dob: res.data.data.dob,
                        position: res.data.data.position
                    })
                })
                .catch(err => {
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again!!!'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }, [dataForm.email])



    return (
        <div className="container">
            <div className="row" >
                <div className="col align-self-center">
                    <div className="row mt-12">
                        <div className="col-12 col-md-12 col-lg-12 mt-0">
                            <div className="card profile-widget mt-0 mt-sm-5 ">
                                <div className="profile-widget-header">
                                    <img alt="image" src="./../assets/img/avatar/avatar-1.png" className="rounded-circle profile-widget-picture" />
                                    <div className="profile-widget-items">
                                        <div className="profile-widget-item">
                                            <div className="profile-widget-item-label">Completed Question</div>
                                            <div className="profile-widget-item-value">{dataForm.message.completed}</div>
                                        </div>
                                        <div className="profile-widget-item">
                                            <div className="profile-widget-item-label">Uncompleted Question</div>
                                            <div className="profile-widget-item-value">{dataForm.message.uncompleted}</div>
                                        </div>
                                        <div className="profile-widget-item">
                                            <div className="profile-widget-item-label">Total Question</div>
                                            <div className="profile-widget-item-value">{dataForm.message.completed + dataForm.message.uncompleted}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="profile-widget-description">
                                    <div className="profile-widget-name">{dataForm.name} {dataForm.displayname != '' ? (<div className="text-muted d-inline font-weight-normal"><div className="slash"></div>{dataForm.displayname}</div>) : ''} </div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">{dataForm.status == 'student' ? 'NIM' : 'NIK'}</label>
                                            <div className="col-sm-10">
                                                <input disabled type="text" className="form-control" value={dataForm.id} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">Email</label>
                                            <div className="col-sm-10">
                                                <input disabled type="text" className="form-control" value={dataForm.email} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">{dataForm.status == 'student' ? 'Department' : 'Workunit'}</label>
                                            <div className="col-sm-10">
                                                <input disabled type="text" className="form-control" value={dataForm.workunit} />
                                            </div>
                                        </div>
                                        {dataForm.status != 'student' ?
                                            (
                                                <div className="form-group row">
                                                    <label className="col-sm-2 col-form-label">Position</label>
                                                    <div className="col-sm-10">
                                                        <input disabled type="text" className="form-control" value={dataForm.position} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="form-group row">
                                                    <label className="col-sm-2 col-form-label">Date of Birth</label>
                                                    <div className="col-sm-10">
                                                        <input disabled type="text" className="form-control" value={new Date(dataForm.dob).toLocaleDateString(['id-ID'])} />
                                                    </div>
                                                </div>
                                            )}
                                        {dataForm.status == 'admin' && statePassword.is_edit ?
                                            (
                                                <Fragment>
                                                    <div className={`form-group row ${statePassword.errOld != null ? 'pb-4' : ''}`}>
                                                        <label htmlFor="old" className="col-sm-2 col-form-label">Current Password</label>
                                                        <div className="input-group  has-validation col-sm-10">
                                                            <input type="password" disabled={!statePassword} className={`form-control ${statePassword.errOld != null ? 'is-invalid' : ''}`} id="old" name="old" autoFocus value={statePassword.old} onChange={handleInputChange} placeholder="Current Password" aria-describedby="validationOldPassword" />
                                                            <div id="validationOldPassword" className="invalid-feedback">
                                                                {statePassword.errOld}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`form-group row ${statePassword.errNew != null ? 'pb-4' : ''}`}>
                                                        <label htmlFor="new" className="col-sm-2 col-form-label">New Password</label>
                                                        <div className="input-group  has-validation col-sm-10">
                                                            <input type="password" disabled={!statePassword} className={`form-control ${statePassword.errNew != null ? 'is-invalid' : ''}`} id="new" name="new" value={statePassword.new} onChange={handleInputChange} placeholder="New Password" aria-describedby="validationNewPassword" />
                                                            <div id="validationNewPassword" className="invalid-feedback">
                                                                {statePassword.errNew}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`form-group row ${statePassword.errOld != null ? 'pb-4' : ''}`}>
                                                        <label htmlFor="confirm" className="col-sm-2 col-form-label">Confirm Password</label>
                                                        <div className="input-group  has-validation col-sm-10">
                                                            <input type="password" disabled={!statePassword} className={`form-control ${statePassword.errConfirm != null ? 'is-invalid' : ''}`} id="confirm" name="confirm" value={statePassword.confirm} onChange={handleInputChange} placeholder="Confirm Password" aria-describedby="validationConfirmPassword" />
                                                            <div id="validationConfirmPassword" className="invalid-feedback">
                                                                {statePassword.errConfirm}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-sm-12">
                                                            <button onClick={handleSubmitPassword} className="btn btn-primary" type="button" style={{ textTransform: 'capitalize', float: 'right' }}>Save</button>
                                                            <button onClick={handleEditPassword} className="btn btn-secondary mr-3" type="button" style={{ textTransform: 'capitalize', float: 'right' }}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            ) : (
                                                <div className="form-group row">
                                                    <div className="input-group m-0 p-0 ">
                                                        <label className="col-sm-2 col-form-label" style={{ fontSize: '12px', fontWeight: '600' }}>Password</label>
                                                        <div className="input-group-append col-sm-10">
                                                            <input type={dataForm.password ? 'text' : 'password'} disabled className="form-control " value={dataForm.password ? 'Same as the KRS password ' : 'dummy password'} />
                                                            {!dataForm.password ? (<button onClick={handleEditPassword} className={`btn btn-${dataForm.status == "save" ? 'primary' : 'success'}`} type="button" style={{ textTransform: 'capitalize' }}>{(dataForm.status == "save") ? 'Save' : 'Edit'}</button>) : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default Profile
